import React, { Component } from 'react';
import { Col, Form } from 'reactstrap';
import { connect } from 'react-redux';
import { DisplayPayBtnText, RenderForm, GoBack, Timer } from 'components/Common';
import { callSetPayment, callCardMetaDataAPI, callGetTxnStatus } from 'actions/payment';
import GlobalLoaderModal from "components/FDModal/global-loader";
import GlobalErrorModal from "components/FDModal/global-error";
import FPConfig from 'lib/config';
import BHIM_UPI_Image from 'assets/images/bhim.png';
import GPAY_UPI_Image from 'assets/images/google-paya.jpeg';
import PHONEPAY_UPI_Image from 'assets/images/phonepay.jpg';
import PAYTM_UPI_Image from 'assets/images/paytm.png';

class WeChat extends Component {
	
	state = { 
		clearGetStatusInterval: 'getStatusInterval', 
		bharatQrString: null, 
		loader: true,
		qrScanComplete:false,
		qrScanSuccess:false
	}

	async componentDidMount(){
		// console.log("Frm WeChat Mount")
    await callCardMetaDataAPI('WECHAT', null)
    const spData = {
      "transactionDetails": {
        "transactionType": "SALE",
        "paymentMethod": "WECHAT"
      }
    }
		this.props.callSetPayment('WECHAT', spData, this.props.txnKey, this.props.txnIv).then((vpa_data)=>{
			let { getTxnStatus, getTxnStatusRequestBean, errorMessage,weChatQrString } = vpa_data.payload.data
			if(errorMessage){
				if(!vpa_data.payload.data.redirectUrl)
					this.setState({loader: false})
			}else if(weChatQrString){
				// For Serializing this object
				var search_params = new URLSearchParams(); 
				search_params.append('cht', 'qr');
				search_params.append('choe', 'UTF-8');
				search_params.append('chs', '300x300');
				search_params.append('chl', weChatQrString);
				const url = `${process.env.REACT_APP_BASE_SERVICE_API_URL}/qrImage?${search_params.toString()}`;
				this.setState({weChatQrString: url})

				if(getTxnStatus){
					let attemptCount = 0
					let timeout = FPConfig.timeout.getTxnStatus/10
					this.getStatusInterval = setInterval(async () => {
						try{
							attemptCount += 1;
							getTxnStatusRequestBean = {...getTxnStatusRequestBean , inquiryNo:attemptCount};
              const res = await callGetTxnStatus(getTxnStatusRequestBean);	
               console.log("RESponse",res.payload);
						  const { transactionStatus, redirectToRetryPayPage } = res.payload
							this.setState({txnStatus: res.payload})
							if(transactionStatus==="SUCCESS"){
								clearInterval(this.getStatusInterval)					
								// document.BHARATQR_SCANForm.submit()
								this.setState({redirectToRetryPayPage, loader: false , qrScanComplete:true,qrScanSuccess:true});
							}else if(transactionStatus==="FAILED"){
								clearInterval(this.getStatusInterval);
								this.setState({redirectToRetryPayPage, loader: false , qrScanComplete:true,qrScanSuccess:false});
								// document.BHARATQR_SCANForm.submit()
							}else if(attemptCount>=timeout){
								clearInterval(this.getStatusInterval)
								// if(redirectToRetryPayPage){ // Retry count should be configurable from merchant							
								// 	this.setState({redirectToRetryPayPage, loader: false , qrScanComplete:true,qrScanSuccess:false})
								// } else {				
								// 	document.BHARATQR_SCANForm.submit()
								// }
								this.setState({redirectToRetryPayPage, loader: false , qrScanComplete:true,qrScanSuccess:false});
							} 
						}catch(error){
							if(attemptCount>=timeout){
								clearInterval(this.getStatusInterval)
								// if(redirectToRetryPayPage){ // Retry count should be configurable from merchant							
								// 	this.setState({redirectToRetryPayPage, loader: false , qrScanComplete:true,qrScanSuccess:false})
								// } else {				
								// 	document.BHARATQR_SCANForm.submit()
								// }
								this.setState({redirectToRetryPayPage:true, 
									loader: false , 
									qrScanComplete:true,
									qrScanSuccess:false,
									txnStatus:{transactionStatus:"FAILED"}
								});
							}

						}
					}, 10000)
				}
			}
		})
	}
	
	componentWillUnmount(){
		clearInterval(this.getStatusInterval)
	}

	render() {
		const { t } = this.props
		const timeout = FPConfig.timeout.getTxnStatus

		if(!this.state.weChatQrString){
			return (
				this.state.loader && <GlobalLoaderModal transaction={false} />
			)
		}
		
		return(
			<Col xs="12">
				<div className="card-details-panel d-flex justify-content-center">
					<Form>		
						<figure className="text-center">
							<img src={this.state.weChatQrString} alt="card" title="" />
							{this.state.weChatQrString && <Timer secondsRemaining={timeout} />}
						</figure>

						<p className="qrTest text-center">{t('scan_note')} </p>
						<div className="container-fluid upi_image_row">
                            <div className="row">
                            <div className="col">
                            <figure className="text-center mb-4">
                            <img className="img-response" src={BHIM_UPI_Image} alt="card" title="" />
                            </figure>
                            </div>
                            <div className="col">
                            <figure className="text-center mb-4">
                            <img className="img-response" src={GPAY_UPI_Image} alt="card" title="" />
                            </figure>
                            </div>
                            <div className="col">
                            <figure className="text-center mb-4">
                            <img className="img-response" src={PHONEPAY_UPI_Image} alt="card" title="" />
                            </figure>
                            </div>
                            <div className="col">
                            <figure className="text-center mb-4">
                            <img className="img-response" src={PAYTM_UPI_Image} alt="card" title="" />
                            </figure>
                            </div>
                            </div>
                      
                        </div>
                        <p className="error text-center ml-1 mr-1">({t(('bharatQR_note'))})</p>
						<div className="bharat-transBtn mb-3">
							<DisplayPayBtnText labelName='TOTAL' transactionDetails={this.props.transactionDetails} t={this.props.t} />
						</div>
						<div className="go-back-site text-center">
							<GoBack t={t} />
						</div>
					</Form>
				</div>
				{/* {this.state.redirectToRetryPayPage && <GlobalErrorModal retryBtn={true} />} */}
				{this.state.qrScanSuccess &&  this.state.qrScanComplete && 
				<RenderForm className='hidden' sessionID = {this.props.SessionToken} nbRespURL={this.state.txnStatus.merchantRedirectUrl} 
				bharatTxnStatus={this.state.txnStatus} formName="WECHAT" />
				}
				{!this.state.qrScanSuccess &&  this.state.qrScanComplete && 
				<RenderForm className='hidden' sessionID = {this.props.SessionToken} nbRespURL={FPConfig.qr_failure} 
				bharatTxnStatus={this.state.txnStatus} formName="WECHAT" />
				}
				
			</Col>
		);
	}
}

const mapStateToProps = state => {
	// console.log("from WeChat", state.fdData)
	const { transactionDetails, txnKey, txnIv,SessionToken } = state.fdData
    let returnProps = { transactionDetails, txnKey, txnIv,SessionToken}
    return { ...returnProps }
}

export default connect(mapStateToProps, { callSetPayment })(WeChat);